const LoadingSpinner = (props: any) => {
  const { isVisible } = props

  if (!isVisible) return <></>

  let classes: string = "loader ease-linear border-t-black rounded-full border-2 border-t-2 h-5 w-5"

  return <div className={classes}></div>
}

export default LoadingSpinner
